// extracted by mini-css-extract-plugin
export default {"group":"CheckBoxList_group__VWwCr","list":"CheckBoxList_list__IViQW","disabled":"CheckBoxList_disabled__WDn-c"};